<template>
    <div>
      
      <router-view></router-view>
    </div>
</template>
<script>
import banner from '@/components/banner'
export default {
  name: 'Technology',
  components: {
    banner
  }
}
</script>
